import styled from 'styled-components';

export const StyledLazyLoading = styled.div`
  height: calc(100vh - 5rem);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
